import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFilterAutocompleteComponent } from './table-filter-autocomplete.component';
import { MaterialModule } from '../../material-components.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../../../utils/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    PipesModule,
  ],
  declarations: [TableFilterAutocompleteComponent],
  exports: [TableFilterAutocompleteComponent],
})

export class TableFilterAutocompleteModule {
}
